<template>
    <div>
      <b-navbar toggleable="md" type="dark" variant="info" class="pt-0 pb-0 bg-blue">
          <b-navbar-toggle target="nav_collapse_actions"></b-navbar-toggle>
          <h1 class="text-center navbar-brand pt-0 pb-0 mb-0">SIET</h1>
          <b-collapse is-nav id="nav_collapse_actions" >
            <b-navbar-nav class="ml-auto">
              <b-row>
                
                <b-col sm="4" class="mt-2">
                  <select v-model="tipo" class="form-control">
                    <option v-for="opcion in tiposPosibles"
                    :value="opcion.id">{{ opcion.nombre}}</option>
                  </select>
                </b-col>
                <b-col sm="6" class="mt-2">                  
                  <date-picker  class="date-picker" v-model="intervalo" lang="es" type="date" 
                  :time-picker-options="timePickerOptions" range confirm :clearable="true"></date-picker>
                </b-col>
                
              </b-row>

              <!-- <select v-model="sedes" multiple class="form-control" v-if="puedeCambiarSede">
                <option disabled value="">---SIN SALON---</option>
                <option v-for="opcion in sedesPosibles"
                :value="opcion.id">{{ opcion.nombre}}</option>
              </select> -->

            </b-navbar-nav>
            <b-navbar-nav  class="ml-auto">
              <b-nav-item  href="#" @click="generarReporte">Generar</b-nav-item>
              <download-excel :disabled="!registros || registros && !registros.length"
                  class="nav-link"
                  :data="registros"
                  :fields="json_fields"
                  worksheet="My Worksheet"
                  name="reporte.xls">
                  Descargar
                </download-excel>
            </b-navbar-nav>
          </b-collapse>
      </b-navbar>
  
        <div class="container-fluid" >
        <div class="reporte_dia table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Nombres del estudiante</th>
                <th scope="col">Apellidos del estudiante</th>
                <th scope="col">Tipo de documento</th>
                <th scope="col">Número de documento</th>
                <th scope="col">Número de celular</th>
                <th scope="col">Correo electrónico</th>
                <th scope="col">Estado civil</th>
                <th scope="col">Fecha de nacimiento</th>
                <th scope="col">Lugar de origen</th>
                <th scope="col">Estrato</th>
                <th scope="col">Régimen de salud</th>
                <th scope="col">Nivel de formación</th>
                <th scope="col">Ocupación</th>
                <th scope="col">Discapacidad</th>
                <th scope="col">Grupo</th>
                <th scope="col">Curso siguiente</th>
                <th scope="col">Fecha entrega de libro</th>
                <th scope="col">Sede avance</th>
                <th scope="col">Sede original </th>
                <th scope="col">Vigencia</th>
                <th scope="col">Género</th>
                <th scope="col">Idioma</th>
                <th scope="col">Curso finalizado</th>
                <th scope="col">Fecha Avance de nivel</th>
                <th scope="col">Resultado</th>
                <th scope="col">Nota IFE</th>
                <th scope="col">Nota final módulo</th>
                <th scope="col">Módulos adquiridos</th>
                <th scope="col">Fecha Matricula</th>
                <th scope="col">Nivel</th>
                <th scope="col">Fecha de inicio del Nivel</th>
                <th scope="col">Fecha de finalización del Nivel</th>
                <th scope="col">Folio</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in registros">
                <td>{{item.estudiante.primer_nombre}} {{item.estudiante.segundo_nombre}}</td>
                <td>{{item.estudiante.primer_apellido}} {{item.estudiante.segundo_apellido}}</td>
                <td>{{item.estudiante.tipo_documento}}</td>
                <td>{{item.estudiante.numero_documento}}</td>
                <td>{{item.estudiante.movil}}</td>
                <td>{{item.estudiante.email}}</td>
                <td>{{item.estudiante.estadoCivil ? item.estudiante.estadoCivil.descripcion : null}}</td>
                <td>{{presentDate(item.estudiante.fecha_nacimiento)}}</td>
                <td>{{item.estudiante.lugar_origen}}</td>
                <td>{{item.estudiante.estrato}}</td>
                <td>{{item.estudiante.regimenSalud ? item.estudiante.regimenSalud.nombre : null}}</td>
                <td>{{item.estudiante.nivelEducativo ? item.estudiante.nivelEducativo.descripcion : ''}}</td>
                <td>{{item.estudiante.ocupacion ? item.estudiante.ocupacion.descripcion : null}}</td>
                <td>{{item.estudiante.discapacidad ? item.estudiante.discapacidad.descripcion : null}}</td>
                <td>{{item.estudiante.grupoEtnico ? item.estudiante.grupoEtnico.descripcion : null}}</td>
                <td>{{item.cursoNuevo ? item.cursoNuevo.nombre : ''}}</td>
                <td>{{presentDate(item.comienza_nivel_en)}}</td><!-- GUARDAR DE INICIO-->
                <td>{{item.sede ? item.sede.nombre : (item.estudiante.sede_original.nombre)}}</td><!-- GUARDAR SEDE EN QUE SE GENERA AVANCE-->
                <td>{{item.estudiante.sede_original.nombre}}</td><!-- GUARDAR SEDE EN QUE SE GENERA AVANCE-->
                <td>{{item.estudiante.vigencia}}</td>
                <td>{{item.estudiante.genero}}</td>
                <td>{{getIdioma(item)}}</td>
                <td>{{item.cursoAnterior ? item.cursoAnterior.nombre : ''}}</td>
                <td>{{presentDate(item.fecha_avance_nivel)}}</td>
                <td>{{item.resultado}}</td>
                <td>{{item.nota_ife}}</td>
                <td>{{item.nota}}</td>
                <td>{{item.estudiante.modulos_adquiridos}}</td>
                <td>{{presentDate(item.estudiante.fecha_matricula)}}</td>
                <td>{{item.nivel}}</td>
                <td>{{presentDate(item.fecha_inicio_nivel)}}</td>
                <td>{{presentDate(item.fecha_fin_nivel)}}</td>
                <td>{{item.folio}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
        
    </div>
  </template>
  
  <script>
    import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
    import Vue from 'vue';
    import DatePicker from 'vue2-datepicker'
  
    export default {
      name: 'ReporteSIET',
      components: {
        DatePicker
      },
      data () {
        return {
            intervalo:[],
            sedes:[],
            registros: [],
            timePickerOptions:{    
            },
            json_fields: {
              "Nombres del estudiante": {
                callback: (value) => {
                  return `${value.estudiante.primer_nombre} ${value.estudiante.segundo_nombre}`;
                }
              },
              "Apellidos del estudiante": {
                callback: (value) => {
                  return `${value.estudiante.primer_apellido} ${value.estudiante.segundo_apellido}`;
                }
              },
              "Tipo de documento":"estudiante.tipo_documento",
              "Número de documento":"estudiante.numero_documento",
              "Número de celular":"estudiante.movil",
              "Correo electrónico":"estudiante.email",
              "Estado civil":"estudiante.estadoCivil.descripcion",
              "Fecha de nacimiento": {
                field: "estudiante.fecha_nacimiento",
                callback: (value) => {
                  return this.presentDate(value);
                },
              },
              "Lugar de origen":"estudiante.lugar_origen",
              "Estrato":"estudiante.estrato",
              "Régimen de salud":"estudiante.regimenSalud.nombre",
              "Nivel de formación":"estudiante.nivelEducativo.descripcion",
              "Ocupación":"estudiante.ocupacion.descripcion",
              "Discapacidad":"estudiante.discapacidad.descripcion",
              "Grupo":"estudiante.grupoEtnico.descripcion",
              "Curso siguiente":"cursoNuevo.nombre",
              "Fecha entrega de libro":{
                field: "comienza_nivel_en",
                callback: (value) => {
                  return this.presentDate(value);
                },
              },
              "Sede avance":"sede.nombre",
              "Sede original":"estudiante.sede_original.nombre",
              "Vigencia":"estudiante.vigencia",
              
              "Género":"estudiante.genero",
              "Idioma":{
                callback: (value) => {
                  return this.getIdioma(value);
                }
              },
              "Curso finalizado":"cursoAnterior.nombre",
              "Fecha de avance de nivel":{
                field: "fecha_avance_nivel",
                callback: (value) => {
                  return this.presentDate(value);
                },
              },
              "Resultado":"resultado",
              "Nota IFE":"nota_ife",
              "Nota final módulo":"nota",
              "Módulos adquiridos":"estudiante.modulos_adquiridos",
              "Fecha de Matricula":{
                field: "estudiante.fecha_matricula",
                callback: (value) => {
                  return this.presentDate(value);
                },
              },
              "Nivel":"nivel",
              "Fecha de inico de Nivel":{
                field: "fecha_inicio_nivel",
                callback: (value) => {
                  return this.presentDate(value);
                },
              },
              "Fecha de finalización de Nivel":{
                field: "fecha_fin_nivel",
                callback: (value) => {
                  return this.presentDate(value);
                },
              },
              "Folio":"folio"
            },
            tiposPosibles:[{id:"Aprueban",nombre:"Aprueban"},{id:"No Aprueban",nombre:"No Aprueban"}, {id:"Todos",nombre:"Todos"}],
            tipo:null,
        }
      },
      mounted () {
        if(!this.todasLasSedes || (this.todasLasSedes && this.todasLasSedes.length==0)){
          this.fetchSedes()
        }
      },
      methods:{
        ...mapActions({
          fetchSedes: 'sedes/fetchLista',
        }),
        ...mapMutations({
          startProcessing: 'startProcessing',
          stopProcessing: 'stopProcessing'
        }),
        
        generarReporte(){
          console.log('Generando reporte....')
          this.startProcessing()
          Vue.http.post('reportes/siet',{
            fecha_inicio:this.$moment(this.intervalo[0]).format('YYYY-MM-DD'),
            fecha_fin:this.$moment(this.intervalo[1]).format('YYYY-MM-DD'),
            sedes:this.sedes,
            tipo: this.tipo
          }).then(
            response =>{
              this.registros = response.data;
            }
          ).catch(error=>{
            console.log(error)
          }).finally(()=>{
            this.stopProcessing()
          })
        },
        presentDate(value){
          if (value) {
            return this.$moment(value).format('DD/MM/YYYY')
          }
          return '';
        },
        getIdioma(item) {
          if (item.cursoAnterior) {
            return item.cursoAnterior ? (item.cursoAnterior.codigo.indexOf('EN') > -1 ? 'Inglés' : 'Frances') : '';
          } else if (item.cursoNuevo) {
            return item.cursoNuevo ? (item.cursoNuevo.codigo.indexOf('EN') > -1 ? 'Inglés' : 'Frances') : '';
          }
          return '';
        }
      },
      computed: {
        ...mapState({
          todasLasSedes: state  => state.sedes.lista,
          user: state => state.auth.user, 
        }), 
        ...mapGetters({
          permiso: 'auth/permiso', 
        }),
        puedeCambiarSede(){
          return this.permiso('2E3F932E')
        },
        sedesPosibles(){
          if(this.user && this.user.data && this.user.data.sedes_permitidas && this.user.data.sedes_permitidas.length>0){
            return this.todasLasSedes.filter(element=>{
              return this.user.data.sedes_permitidas.includes(element.id) 
            })
          }
          return false
        }
      }
    }
  </script>
  
  <style scope>
  
  .date-picker{
    
  }
  </style>